import clsx from "clsx";
import React, { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import ReactModal from "react-modal";
import Footer from "../sections/Footer";
import HeaderWrapper from "../sections/header/HeaderWrapper";
import { PageDataProvider, useLayout } from "./core";
import LoadingSpinner from "../components/LoadingSpinner";
import SideBarWrapper from "../sections/SideBarWrapper";
import TelephonyFrontend from "../components/TelephonyFrontend/TelephonyFrontend";
import "./styles.scss";
import { TELEPHONY_LOGIN, CIRCLEONE_TEAM } from "../constants";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import {
  Home,
  Mail,
  Settings,
  People,
  Menu as MenuIcon,
  ChevronLeft,
  ChevronRight,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useGetAllTeamsByIdQuery } from "../../src/Services/email/EmailTemplate";
import { useTeamsQuery } from "../Services/settingsAPIs/CommonAPI";
import HeaderContents from "../sections/header/HeaderContents";
import { KTSVG } from "../helpers/components/KTSVG";
import { toAbsoluteUrl } from "../helpers";
import { size } from "lodash";
import SaveModal from "../sections/header/top-right/SaveModal";
import MobileHeaderContent from "../sections/header/MobileHeaderContent";

const MasterLayout = () => {
  const { classes } = useLayout();
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:991px)");
  const isSmallMobile = useMediaQuery("(max-width:575px)");
  const [showVisible, setShowVisible] = useState(false);
  const [isTelephonyVisible, setIsTelephonyVisible] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedTeam, setSelectedTeam] = useState<any>([]);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState<boolean>(false);
  const tenantName = window.location.hostname.split(".")[0];
  const teamName = localStorage.getItem(CIRCLEONE_TEAM);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 560);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 560);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { data: getTeamsById } = useGetAllTeamsByIdQuery(
    localStorage.getItem("User_Id")
  );

  const { data: teams } = useTeamsQuery({});

  const toggleTelephony = () => {
    setIsTelephonyVisible((prev) => !prev);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  const teamChange = (team: any) => {
    setSelectedTeam(team);
    openSaveModal();
  };

  const openSaveModal = () => {
    setIsSaveModalOpen(true);
  };

  const closeSaveModal = () => {
    setIsSaveModalOpen(false);
  };

  const afterOpenSaveModal = () => {
    // Any logic to run after modal opens
  };

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      zIndex: 9999,
      padding: '0',
    },
    overlay: {
      zIndex: 9998,
    },
  };

  // Close mobile menu when transitioning to desktop
  useEffect(() => {
    if (!isMobile && mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  }, [isMobile, mobileMenuOpen]);

  useEffect(() => {
    const updateShowVisible = () => {
      const login = localStorage.getItem(TELEPHONY_LOGIN);
      setShowVisible(login === "true");
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.key === TELEPHONY_LOGIN) {
        updateShowVisible();
      }
    };

    window.addEventListener("storage", handleStorage);

    let pollInterval: NodeJS.Timeout | undefined;
    pollInterval = setInterval(updateShowVisible, 1000);

    updateShowVisible();

    return () => {
      window.removeEventListener("storage", handleStorage);
      if (pollInterval) clearInterval(pollInterval);
    };
  }, []);

  console.log(showVisible, "test");

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <PageDataProvider>
      <div
        style={{
          display: "flex",
          gap: "10px",
          height: "100vh",
          overflow: "hidden",
          zIndex:0
        }}
      >
        {/* Desktop Drawer - Always in DOM */}
        <Drawer
          variant="permanent"
          sx={{
            width: 60,
            flexShrink: 0,
            display: { xs: "none", md: "none", lg: "none", xl: "none" },
            "@media (min-width: 992px)": {
              display: "block",
            },
            "& .MuiDrawer-paper": {
              width: 80,
              overflowX: "hidden",
              overflowY: "auto",
              marginTop: "70px",
              height: "calc(100vh - 70px)",
              position: "fixed",
              left: 0,
            },
          }}
        >
          {/* Menu Items */}
          <HeaderContents />
        </Drawer>

        {/* Mobile Drawer - Only render when in mobile view */}
        {isMobile && (
          <Drawer
            anchor="left"
            open={mobileMenuOpen}
            onClose={toggleMobileMenu}
            sx={{
              "& .MuiDrawer-paper": {
                width: isSmallMobile ? 220 : 280,
                paddingTop: 0,
              },
            }}
          >
            {/* Drawer Header with Close Button */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 16px",
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <img
                  alt="Logo"
                  src={toAbsoluteUrl(
                    "/media/logos/CircleOne-Logo-With-Change.png"
                  )}
                  style={{ height: "32px" }}
                />
                <span style={{ fontSize: "16px", fontWeight: 600 }}>Menu</span>
              </Box>
              <div className="d-flex">
              {!isDesktop && (
                <div className="dropdown ">
                  <button
                    className="btn dropdown-toggle d-flex align-items-center text-dark fw-bolder my-1"
                    type="button"
                    id="dropdownMenuButton3"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {teamName}
                  </button>
                  {getTeamsById?.role === "admin" ? (
                    <ul className="dropdown-menu dropdown-menu-end p-2">
                      {teams
                        ?.slice() // Create a shallow copy of teams to avoid mutating the original array
                        .sort((a: any, b: any) => a.name.localeCompare(b.name)) // Sort teams alphabetically by name
                        .map((team: any) => (
                          <div
                            key={team.id} // Ensure each team has a unique key
                            className={`dropdown-item ${teamName === team.name ? "primary" : ""
                              }`}
                            onClick={() => teamChange(team)}
                          >
                            {team.name}
                          </div>
                        ))}
                    </ul>
                  ) : (
                    <ul className="dropdown-menu dropdown-menu-end p-2">
                      {getTeamsById?.teams
                        ?.slice()
                        .sort((a: any, b: any) => a.name.localeCompare(b.name)) // Sort teams alphabetically by name
                        .map((team: any) => (
                          <div
                            key={team.id} // Ensure each team has a unique key
                            className={`dropdown-item ${teamName === team.name ? "primary" : ""
                              }`}
                            onClick={() => teamChange(team)}
                          >
                            {team.name}
                          </div>
                        ))}
                    </ul>
                  )}
                </div>
              )}
              <IconButton
                onClick={toggleMobileMenu}
                size="small"
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
              </div>
            </Box>

            {/* Menu Contents */}
            <Box sx={{ overflowY: "auto", flex: 1 }}>
              <MobileHeaderContent collapsed={false} />
            </Box>
          </Drawer>
        )}

        <div
          style={{
            width: isMobile
              ? "100%"
              : `calc(100% - ${collapsed ? 70 : 210}px - 10px)`,
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            transition: "width 0.3s",
          }}
        >
          <div
            className="page d-lg-flex flex-row flex-column-fluid"
            style={{
              flex: 1,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              paddingTop: isMobile ? "60px" : 0,
            }}
          >
            {/* <SideBarWrapper /> */}
            <div
              className="wrapper d-flex flex-column flex-row-fluid px-0 pt-15 mt-lg-20"
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <HeaderWrapper onMobileMenuToggle={toggleMobileMenu} />

              {!!showVisible && tenantName !== "cloudtelephony" && (
                <div
                  style={{
                    padding: isTelephonyVisible ? "5px 20px" : "0px",
                  }}
                  className="telephony-container"
                >
                  <div
                    className={clsx("telephony-wrapper", {
                      "telephony-hide": !isTelephonyVisible,
                    })}
                  >
                    <TelephonyFrontend />
                  </div>

                  <span
                    onClick={toggleTelephony}
                    style={{
                      padding: isTelephonyVisible ? "4px" : "0 25px",
                      cursor: "pointer",
                    }}
                    className=""
                  >
                    {isTelephonyVisible ? (
                      <>
                        <i
                          className="bi bi-chevron-up"
                          style={{ color: "black" }}
                        ></i>
                      </>
                    ) : (
                      <>
                        <i
                          className="bi bi-chevron-down"
                          style={{ color: "black" }}
                        ></i>
                      </>
                    )}
                  </span>
                </div>
              )}
              <div
                id="kt_content"
                className="d-flex flex-column flex-column-fluid mt-n13"
                style={{ flex: 1, overflowY: "auto", overflowX: "auto" }}
              >
                <div className="post d-flex flex-column-fluid" id="kt_post">
                  <div
                    id="kt_content_container"
                    style={{
                      width: collapsed ? "100%" : "100%",
                      overflow: "none",
                    }}
                  >
                    <Suspense fallback={<LoadingSpinner />}>
                      <Outlet />
                    </Suspense>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer fixed at bottom */}
          <Footer />
        </div>
      </div>

      <ReactModal
        isOpen={isSaveModalOpen}
        onAfterOpen={afterOpenSaveModal}
        onRequestClose={closeSaveModal}
        style={customModalStyles}
        contentLabel="Save"
        shouldCloseOnOverlayClick={false}
      >
        <SaveModal
          closeSaveModal={closeSaveModal}
          selectedTeam={selectedTeam}
        />
      </ReactModal>
    </PageDataProvider>
  );
};

export { MasterLayout };